<template>
    <div>
        <div class=" mb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  ">Welcome Back
                                </h1>
                                <p>We have missed you.</p>
                            </div>
                            <div class="col-lg-6">
                                <base-alert v-if="errors.length" type="danger">
                                    <b>You have the following error(s):</b>
                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                </base-alert>
                                <div class="card bg-white p-4">
                                    <h2>Create Account</h2>
                                    <div class="row">
                                        <div class="col">
                                            <base-input alternative="" v-model="firstName" placeholder="First Name" input-classes="form-control" required />
                                        </div>
                                        <div class="col">
                                            <base-input alternative="" v-model="lastName" placeholder="Last Name" input-classes="form-control" />
                                        </div>
                                    </div>
                                    <base-input alternative="" type="email" v-model="email" placeholder="Email" input-classes="form-control" required />
                                    <base-input alternative="" type="password" v-model="password" placeholder="Password" input-classes="form-control" required />
                                    <base-input alternative="" type="password" v-model="confirmPassword" placeholder="Confirm Password" input-classes="form-control" required />
                                    <a-checkbox :checked="dataPrivacyConsentStatus" @change="onChangeDataPrivacyConsent" class="mb-3">
                                        I accept the <b> Terms of Use</b> & <b>Privacy Policy</b> 
                                    </a-checkbox>
                                    <a-button type="primary" size="large" class="btn btn-primary btn-large" :disabled="!dataPrivacyConsentStatus" :loading="createLoading" @click.prevent="create">
                                        CREATE
                                    </a-button>
                                    <p class="text-center mt-3"> OR </p>
                                    <div class="btn-wrapper text-center w-100 mb-3">
                                        <v-facebook-login app-id="3199557610083038" @sdk-init="handleSdkInit" class="d-none" @login="FBLogin" />
                                        <a type="button" class="btn btn-neutral border btn-icon" @click.prevent="scope.login" style="width: 48%;">
                                            <span class="btn-inner--icon"><img src="https://upload.wikimedia.org/wikipedia/commons/f/ff/Facebook_logo_36x36.svg"></span>
                                            <span class="btn-inner--text">Facebook</span>
                                        </a>
                                        <GoogleLogin :params="params" class="btn btn-neutral border btn-icon" style="width: 48%;" :onSuccess="onSuccess" :onFailure="onFailure">
                                            <span class="btn-inner--icon"><img src="https://demos.creative-tim.com/argon-dashboard/assets/img/icons/common/google.svg"></span>
                                            <span class="btn-inner--text">Google</span>
                                        </GoogleLogin>
                                    </div>
                                    <router-link :to="{ name: 'customer_login', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}">
                                        <i class="fa fa-long-arrow-left"></i>  Return to Login
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>

<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import CookieConsent from 'vue-cookieconsent-component'
import VFacebookLogin from 'vue-facebook-login-component'
import { mapState, mapActions } from 'vuex'
import GoogleLogin from 'vue-google-login'
var component_x
export default {
    components: {
        HTTPRequest,
        CookieConsent,
        GoogleLogin,
        VFacebookLogin
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            email:null,
            password:null,
            confirmPassword:null,
            lastName:null,
            firstName:null,
            errors:[],
            cookiesConsentStatus:null,
            cookiesConsentStatusGivenAt:null,
            createLoading:false,
            params: {
                client_id: "157339439449-sfmoirvcm6uvluhu9d5421jtjm2vlrsr.apps.googleusercontent.com"
            },
            FB: {},
            model: {},
            scope: {},
            dataPrivacyConsentStatus:false,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            component_x = this
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            if (secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus") == true){
                this.$router.push({ name: 'store', params:{storeId:this.$route.params.storeId}})
            }
            this.cookiesConsentStatus = CookieConsent.methods.getCookie(this.storeDetails.account_id+'_'+this.storeDetails.name+'_cookieconsent_status')
            this.cookiesConsentStatusGivenAt = CookieConsent.methods.getCookie(this.storeDetails.account_id+'_'+this.storeDetails.name+'_cookieconsent_datetime') 
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'customer_register', storeId:this.$route.params.storeId }})
        }
    },
    methods:{
        CreateValidation(){
            this.errors = [];
            this.errors.push(ValidateField.required('First Name', this.firstName));
            this.errors.push(ValidateField.required('Last Name', this.lastName));
            this.errors.push(ValidateField.required('Email', this.email));
            this.errors.push(ValidateField.required('Password', this.password));
            this.errors.push(ValidateField.required('Confirm Password', this.confirmPassword));
            this.errors.push(ValidateField.matchData('Password',this.password,this.confirmPassword));
            this.errors = this._.compact(this.errors);
            return this.errors.length;
        },
        create: async function(){
            if(!this.CreateValidation()) {
                this.createLoading = true
                var CustomerPayload = {
                    customer: {
                        first_name: this.firstName.trim(), 
                        last_name: this.lastName.trim(),
                        name:this.firstName+' '+this.lastName.charAt(0).toUpperCase()+'.',
                        email:this.email,
                        password:this.password,
                    }
                }
                this.cookiesConsentStatus != null ? CustomerPayload.customer.consent = {cookies_consent:this.cookiesConsentStatus,cookies_consent_given_at:this.cookiesConsentStatusGivenAt,} : ''
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers?name='+this.storeDetails.name+'&account_id='+this.storeDetails.account_id, null, CustomerPayload)    
                if (post_request["error"] == undefined) {
                    this.$notification['success']({
                        message: 'Success',
                        description: "Congratulations, your account has been successfully created",
                    });
                    this.createLoading = false
                    this.$router.push({ name: 'customer_login', params:{storeId:this.$route.params.storeId}})
                }else{
                    this.errors = post_request["error"].split(",")
                    this.createLoading = false
                }
            }
        },
        onSuccess: async function(googleUser) {
            this.createLoading = true
            var CustomerPayload = {
                customer: {
                    first_name: googleUser.getBasicProfile().getGivenName(), 
                    last_name: googleUser.getBasicProfile().getFamilyName(),
                    name:googleUser.getBasicProfile().getGivenName()+' '+googleUser.getBasicProfile().getFamilyName(),
                    email:googleUser.getBasicProfile().getEmail(),
                }
            }
            this.cookiesConsentStatus != null ? CustomerPayload.customer.consent = {cookies_consent:this.cookiesConsentStatus,cookies_consent_given_at:this.cookiesConsentStatusGivenAt,} : ''
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers/register_using_gmail_or_facebook?name='+this.storeDetails.name+'&account_id='+this.storeDetails.account_id, null, CustomerPayload)    
            console.log(post_request)
            if (post_request["error"] == undefined) {
                this.$notification['success']({
                    message: 'Success',
                    description: "Congratulations, your account has been successfully created",
                });
                this.createLoading = false
                this.$router.push({ name: 'customer_login', params:{storeId:this.$route.params.storeId}})
            }else{
                this.errors = post_request["error"].split(",")
                this.createLoading = false
            }
        },
        onFailure(error){

        },
        handleSdkInit({ FB, scope }) {
            this.FB = FB
            this.scope = scope
        },
        FBLogin(response){
            console.log(response.authResponse)
            if (response.authResponse) {
                this.FB.api('/me', {locale: 'en_US', fields: 'id,first_name,last_name,email,link,gender,locale,picture'},
                function (response) {
                    console.log(response);
                    component_x.createCustomerUsingFB(response)
                });
            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        },
        createCustomerUsingFB: async function(res){
            var CustomerPayload = {
                customer: {
                    first_name: res.first_name, 
                    last_name: res.last_name,
                    name:res.first_name+' '+res.last_name,
                    email:res.email,
                }
            }
            this.cookiesConsentStatus != null ? CustomerPayload.customer.consent = {cookies_consent:this.cookiesConsentStatus,cookies_consent_given_at:this.cookiesConsentStatusGivenAt,} : ''
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers/register_using_gmail_or_facebook?name='+this.storeDetails.name+'&account_id='+this.storeDetails.account_id, null, CustomerPayload)    
            console.log(post_request)
            if (post_request["error"] == undefined) {
                this.$notification['success']({
                    message: 'Success',
                    description: "Congratulations, your account has been successfully created",
                });
                this.createLoading = false
                this.$router.push({ name: 'customer_login', params:{storeId:this.$route.params.storeId}})
                this.fbLogOut()
            }else{
                this.errors = post_request["error"].split(",")
                this.createLoading = false
                this.fbLogOut()
            }
        },
        fbLogOut(){
            this.scope.logout(function(res){
                console.log(res)
            })
        },
        onChangeDataPrivacyConsent(e){
            this.dataPrivacyConsentStatus = e.target.checked;  
        }
    }
};
</script>
